import { defineComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, renderSlot, withModifiers, withKeys, createCommentVNode, ref, watchEffect, createBlock, resolveDynamicComponent, withCtx } from "vue";
var popupMixin = defineComponent({
  props: {
    infoForProps: Object,
    type: String
  },
  methods: {
    closePopup() {
      this.$emit("closeChildWindow");
    },
    applyPopup() {
      this.$emit("applyChildWindow");
    }
  }
});
var StatusPopup_vue_vue_type_style_index_0_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$3 = defineComponent({
  mixins: [popupMixin]
});
const _hoisted_1$3 = /* @__PURE__ */ createElementVNode("div", { class: "popup-img" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "img" })
], -1);
const _hoisted_2$3 = { class: "popup-title" };
const _hoisted_3$2 = { class: "title" };
const _hoisted_4$2 = { class: "popup-msg" };
const _hoisted_5$1 = { class: "popup-btn" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["popup status-popup", `${_ctx.type}-popup`])
  }, [
    _hoisted_1$3,
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("h3", _hoisted_3$2, toDisplayString(_ctx.infoForProps.title), 1)
    ]),
    createElementVNode("div", _hoisted_4$2, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", _hoisted_5$1, [
      _ctx.infoForProps["applyBtn"] ? (openBlock(), createElementBlock("button", {
        key: 0,
        class: "submit",
        type: "submit",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.applyPopup(), ["prevent"])),
        onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => _ctx.applyPopup(), ["enter"])),
        autofocus: ""
      }, toDisplayString(_ctx.infoForProps.applyBtn), 33)) : _ctx.infoForProps["closeBtn"] ? (openBlock(), createElementBlock("button", {
        key: 1,
        class: "close",
        type: "submit",
        onClick: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.closePopup(), ["prevent"])),
        onKeyup: _cache[3] || (_cache[3] = withKeys(($event) => _ctx.closePopup(), ["enter"])),
        autofocus: ""
      }, toDisplayString(_ctx.infoForProps.closeBtn), 33)) : createCommentVNode("", true)
    ])
  ], 2);
}
var StatusPopup = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
var DialogPopup_vue_vue_type_style_index_0_lang = "";
const _sfc_main$2 = defineComponent({
  mixins: [popupMixin]
});
const _hoisted_1$2 = { class: "popup dialog-popup" };
const _hoisted_2$2 = { class: "popup-title" };
const _hoisted_3$1 = { class: "title" };
const _hoisted_4$1 = { class: "popup-msg" };
const _hoisted_5 = { class: "popup-btn" };
const _hoisted_6 = { class: "btn-wrapper btn-wrapper_left" };
const _hoisted_7 = { class: "btn-wrapper btn-wrapper_right" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("div", _hoisted_2$2, [
      createElementVNode("h3", _hoisted_3$1, toDisplayString(_ctx.infoForProps.title), 1),
      createElementVNode("button", {
        class: "popup-close",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.closePopup())
      })
    ]),
    createElementVNode("div", _hoisted_4$1, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", _hoisted_5, [
      createElementVNode("div", _hoisted_6, [
        createElementVNode("button", {
          class: "close",
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.closePopup())
        }, toDisplayString(_ctx.infoForProps.closeBtn), 1)
      ]),
      createElementVNode("div", _hoisted_7, [
        createElementVNode("button", {
          class: "submit",
          type: "submit",
          onClick: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.applyPopup(), ["prevent"])),
          onKeyup: _cache[3] || (_cache[3] = withKeys(($event) => _ctx.applyPopup(), ["enter"])),
          autofocus: ""
        }, toDisplayString(_ctx.infoForProps.applyBtn), 33)
      ])
    ])
  ]);
}
var DialogPopup = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
var InfoPopup_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1 = defineComponent({
  mixins: [popupMixin]
});
const _hoisted_1$1 = { class: "popup-title" };
const _hoisted_2$1 = { class: "title" };
const _hoisted_3 = { class: "popup-msg" };
const _hoisted_4 = { class: "popup-btn" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["popup info-popup", `${_ctx.type}-popup`])
  }, [
    createElementVNode("div", _hoisted_1$1, [
      createElementVNode("h3", _hoisted_2$1, toDisplayString(_ctx.infoForProps.title), 1)
    ]),
    createElementVNode("div", _hoisted_3, [
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", _hoisted_4, [
      _ctx.infoForProps["applyBtn"] ? (openBlock(), createElementBlock("button", {
        key: 0,
        class: "submit",
        type: "submit",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.applyPopup(), ["prevent"])),
        onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => _ctx.applyPopup(), ["enter"])),
        autofocus: ""
      }, toDisplayString(_ctx.infoForProps.applyBtn), 33)) : _ctx.infoForProps["closeBtn"] ? (openBlock(), createElementBlock("button", {
        key: 1,
        class: "close",
        type: "submit",
        onClick: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.closePopup(), ["prevent"])),
        onKeyup: _cache[3] || (_cache[3] = withKeys(($event) => _ctx.closePopup(), ["enter"])),
        autofocus: ""
      }, toDisplayString(_ctx.infoForProps.closeBtn), 33)) : createCommentVNode("", true)
    ])
  ], 2);
}
var InfoPopup = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
var ModalWindow_vue_vue_type_style_index_0_lang = "";
const _sfc_main = defineComponent({
  components: {
    StatusPopup,
    DialogPopup,
    InfoPopup
  },
  props: {
    type: String,
    openFlag: Boolean,
    infoForProps: Object
  },
  beforeCreate() {
    document.body.classList.add("lock-body");
  },
  emits: ["closeModalWindow", "applyModalWindow"],
  setup(props, { emit }) {
    const componentName = ref("");
    const visiblePopup = ref(false);
    const setComponentName = () => {
      switch (props.type) {
        case "success":
          componentName.value = "StatusPopup";
          break;
        case "failed":
          componentName.value = "StatusPopup";
          break;
        case "pending":
          componentName.value = "StatusPopup";
          break;
        case "dialog":
          componentName.value = "DialogPopup";
          break;
        case "default":
          componentName.value = "InfoPopup";
          break;
        default:
          componentName.value = "";
          break;
      }
    };
    const setProps = () => {
      visiblePopup.value = props.openFlag;
      setComponentName();
    };
    const closePopup = () => {
      emit("closeModalWindow");
      document.body.classList.remove("lock-body");
    };
    const applyPopup = () => {
      emit("applyModalWindow");
      document.body.classList.remove("lock-body");
    };
    watchEffect(() => {
      setProps();
    });
    return {
      visiblePopup,
      closePopup,
      applyPopup,
      componentName
    };
  }
});
const _hoisted_1 = {
  key: 0,
  class: "modal-window"
};
const _hoisted_2 = { class: "modal-window-popup" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.visiblePopup ? (openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      class: "modal-window__background",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.closePopup())
    }),
    createElementVNode("div", _hoisted_2, [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.componentName), {
        onCloseChildWindow: _cache[1] || (_cache[1] = ($event) => _ctx.closePopup()),
        onApplyChildWindow: _cache[2] || (_cache[2] = ($event) => _ctx.applyPopup()),
        infoForProps: _ctx.infoForProps,
        type: _ctx.type
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 40, ["infoForProps", "type"]))
    ])
  ])) : createCommentVNode("", true);
}
var ModalWindow = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
var ModalWindowPlugin = {
  install: (app, options = { img: "" }) => {
    app.component("ModalWindow", ModalWindow);
    app.provide("specialUploadImage", options.img);
  }
};
export { ModalWindow, ModalWindowPlugin as default };
